// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_CriaTicketInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /tickets/criaTicket
 *
 * Creates a new ticket.
 */
import { registerContract } from './validate'

export interface Tickets_CriaTicketInput {
Titulo: string
Prioridade: number
Descricao: string
Usuario: string
CategoriaID: number
}

registerContract('Tickets_CriaTicketInput', {
  Titulo:      { type: 'string',  required: true },
  Prioridade:  { type: 'number',  required: true },
  Descricao:   { type: 'string',  required: true },
  Usuario:     { type: 'string',  required: true },
  CategoriaID: { type: 'number',  required: true },
})
